import React, { useState } from "react";
import { Route, Link, withRouter, Switch } from "react-router-dom";
import { Pane, toaster } from "evergreen-ui";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Navbar, NavContainer, Divider, NavButton } from "../components";
import gql from "graphql-tag";
import Types from "./Types";
import Type from "./Type";
import Doc from "./Doc";
import Docs from "./Docs";
import Section from "./Section";
import Users from "./Users";
import Logout from "./Logout";
import Profile from "./Profile";

const GET_ME = gql`
  query Me {
    me
  }
`;

const LOGIN_USER = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password)
  }
`;

const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

const CHANGE_PASSWORD = gql`
  mutation ChangePassword($token: String!, $password: String!) {
    changeUser(token: $token, password: $password)
  }
`;

const ResetForm = props => {
  const [password, setPassword] = useState("");
  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted: () => {
      toaster.success("Hasło zmieniono, możesz się teraz zalogować...");
      setTimeout(() => {
        window.location = "/";
      }, 2000);
    }
  });
  return (
    <div>
      <input
        placeholder="wpisz nowe hasło..."
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <button
        onClick={() => {
          changePassword({
            variables: {
              token: props.match.params.id,
              password
            }
          });
        }}
      >
        Zmień
      </button>
    </div>
  );
};

export default () => {
  const { data, error, loading } = useQuery(GET_ME);
  if (error) return <Pane>Error</Pane>;
  if (loading) return <Pane>Ładowanie...</Pane>;
  const { me } = data;
  if (!me)
    return (
      <Switch>
        <Route path="/reset/:id" component={ResetForm} />
        <Route component={Login} />
      </Switch>
    );
  const [id, role] = me.split("-");
  return <LoggedIn role={role} id={id} />;
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [loginUser, { data }] = useMutation(LOGIN_USER, {
    onCompleted: data => {
      if (data.loginUser === "WRONG PASSWORD") toaster.danger("Błędne hasło");
    }
  });
  const [resetPassword] = useMutation(RESET_PASSWORD, {
    onCompleted: () => {
      toaster.success(
        "Jeśli mamy Twój email w bazie, wysłaliśmy Ci emaila z linkiem do resetu hasła"
      );
    }
  });
  console.log(data);
  return (
    <>
      Logowanie
      <input
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="email..."
      />
      <input
        placeholder="hasło..."
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <button
        onClick={() => {
          loginUser({
            variables: { email: email, password: password },
            refetchQueries: ["Me"]
          });
        }}
      >
        send
      </button>
      <br />
      <br />
      <br />
      RESET hasła
      <input
        value={resetEmail}
        onChange={e => setResetEmail(e.target.value)}
        placeholder="email..."
      />
      <button
        onClick={() => {
          resetPassword({
            variables: { email: resetEmail }
          });
        }}
      >
        send
      </button>
    </>
  );
};

const GET_TYPES = gql`
  query Types {
    types {
      _id
      data
    }
  }
`;

const GET_DOCS = gql`
  query Docs {
    docs {
      _id
      data
    }
  }
`;

const finchDomains = ["localhost", "finch.storwork.pl"];
const LoggedIn = withRouter(props => {
  const { role, id } = props;
  const [menuShown, setMenuShown] = useState(false);
  const { data: data1, error: error1, loading: loading1 } = useQuery(GET_TYPES);
  const { data: data2, error: error2, loading: loading2 } = useQuery(GET_DOCS);
  if (error1 || error2) return <Pane>Error</Pane>;
  if (loading1 || loading2) return <Pane>Ładowanie...</Pane>;
  const { types } = data1;
  const { docs } = data2;
  const mainPath = props.location.pathname.split("/")[1];
  const hasCustomDomain = !finchDomains.includes(window.location.hostname);

  const activeDoc = window.localStorage.getItem("activeDocs");
  if (!activeDoc && hasCustomDomain) {
    const domainApp = docs.find(
      doc => JSON.parse(doc.data).name === window.location.hostname
    )._id;
    window.localStorage.setItem("activeDocs", domainApp);
    window.location.reload();
  }
  // const activeDocsObject = docs.find(el => el._id === activeDoc)
  // const data = JSON.parse(activeDocsObject.data)
  // console.log(data)
  const sections = !activeDoc
    ? []
    : JSON.parse(docs.find(el => el._id === activeDoc).data).sections;
  return (
    <>
      {menuShown && (
        <Pane
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          background={"rgba(0,0,0,0.7)"}
          zIndex={1000000}
          onClick={() => setMenuShown(false)}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          {sections.map(section => {
            if (section.view === "admin" && role !== "admin") return null;
            return (
              <React.Fragment key={section._id}>
                <Link style={{ color: "white" }} to={"/section/" + section._id}>
                  {section.name}
                </Link>
              </React.Fragment>
            );
          })}

          {role === "admin" && (
            <>
              <Link style={{ color: "white" }} to="/users">
                Użytkownicy
              </Link>
              {!hasCustomDomain && (
                <>
                  <Link style={{ color: "white" }} to="/docs">
                    Aplikacje
                  </Link>
                  <Link style={{ color: "white" }} to="/types">
                    Typy
                  </Link>
                </>
              )}
            </>
          )}
          <Link style={{ color: "white" }} to="/profile">
            Profil
          </Link>
          <Link style={{ color: "white" }} to="/logout">
            Wyloguj
          </Link>
        </Pane>
      )}
      <Navbar
        height={48}
        background="#2f3640"
        partial={
          <>
            <NavContainer float="left">
              {!hasCustomDomain && (
                <>
                  <img
                    src="/white.png"
                    style={{
                      height: 32,
                      margin: "8px 16px"
                    }}
                  />
                  <Divider />
                </>
              )}
            </NavContainer>
            <NavContainer float="right">
              <Divider />
              <Pane
                width="50px"
                height="50px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="white"
                onClick={() => setMenuShown(true)}
              >
                <i data-eva='menu-outline' data-eva-fill='white' />
              </Pane>
            </NavContainer>
          </>
        }
        full={
          <>
            <NavContainer float="left">
              {!hasCustomDomain && (
                <>
                  <img
                    src="/white.png"
                    style={{
                      height: 32,
                      margin: "8px 16px"
                    }}
                  />
                  <Divider />
                </>
              )}
              {activeDoc && (
                <>
                  {sections.map(section => {
                    if (section.view === "admin" && role !== "admin")
                      return null;
                    return (
                      <React.Fragment key={section._id}>
                        <NavButton
                          icon={section.icon}
                          title={section.name}
                          to={"/section/" + section._id}
                        />
                        <Divider />
                      </React.Fragment>
                    );
                  })}
                </>
              )}
            </NavContainer>
            <NavContainer float="right">
              {role === "admin" && (
                <>
                  <Divider />
                  <NavButton
                    title="Użytkownicy"
                    to="/users"
                    active={mainPath === "users"}
                    icon="people-outline"
                  />
                  {!hasCustomDomain && (
                    <>
                      <Divider />
                      <NavButton
                        title="Aplikacje"
                        to="/docs"
                        active={mainPath === "docs"}
                        icon="globe-outline"
                      />
                      <Divider />
                      <NavButton
                        title="Typy"
                        to="/types"
                        active={mainPath === "types"}
                        icon="settings-2-outline"
                      />
                    </>
                  )}
                </>
              )}
              <Divider />
              <NavButton
                title="Profil"
                to="/profile"
                active={mainPath === "profile"}
                icon="person-outline"
              />
              <Divider />
              <NavButton
                title="Wyloguj"
                to="/logout"
                active={mainPath === "logout"}
                icon="log-out-outline"
              />
            </NavContainer>
          </>
        }
      />
      <Route
        path="/docs"
        exact
        render={props => <Docs {...props} docs={docs} />}
      />
      <Route
        path="/docs/:id"
        render={props => (
          <Doc
            {...props}
            types={types}
            doc={docs.find(el => el._id === props.match.params.id)}
          />
        )}
      />
      <Route
        path="/types"
        exact
        render={props => <Types {...props} types={types} />}
      />
      <Route
        path="/types/:id"
        exact
        render={props => (
          <Type
            {...props}
            types={types}
            type={types.find(el => el._id === props.match.params.id)}
          />
        )}
      />
      <Route path="/users" exact render={props => <Users {...props} />} />
      <Route
        path="/profile"
        exact
        render={props => <Profile userId={id} {...props} />}
      />
      <Route path="/logout" exact render={props => <Logout {...props} />} />
      <Route
        path="/section/:section"
        exact
        render={props => {
          return (
            <Section
              role={role}
              key={props.match.params.section}
              {...props}
              types={types}
              sectionId={props.match.params.section}
              doc={docs.find(el => el._id === activeDoc)}
            />
          );
        }}
      />
    </>
  );
});
